import {PrsStatus} from "core/const/PrsStatus";

import * as S from './StatusLabel.style';

export type StatusLabelProps = {
  status: PrsStatus;
};

const PRSStatusLabels: Record<string, string> = {
  [PrsStatus.Unpaid]: 'Unpaid',
  [PrsStatus.Ongoing]: 'Ongoing',
  [PrsStatus.Paid]: 'Paid',
  [PrsStatus.Cancelled]: 'Cancelled',
  [PrsStatus.Submitted]: 'Submitted',
};

export const StatusLabel = ({ status }: StatusLabelProps) => {
  return <S.Label status={status}>{PRSStatusLabels[status]}</S.Label>;
};
